import React, { useEffect, useState } from "react";
import { Button, Tooltip, Typography } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import no_notification from "../../User/assets/no-notification.svg";
import instance from "../../Utils/api";
import { toast } from "react-toastify";

const ApprovePay = () => {
  const navigate = useNavigate();

  const [payments, setPayments] = useState([]);

  const getPayments = async () => {
    try {
      const response = await instance.get("/Payment/getPayments");
      const paymentFilter = response?.data?.data.filter(
        (item) => item?.status === "Pending"
      );
      setPayments(paymentFilter);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getPayments();
  }, []);

  return (
    <React.Fragment>
      <section className="mycart">
        <div className="mycart-title">
          <Button >
            <KeyboardBackspaceIcon />
            Back
          </Button>
          <Typography variant="h4">Pay/Approve</Typography>
        </div>
        <React.Fragment>
          {payments.length === 0 ? (
            <React.Fragment>
              <div className="cart-no-items">
                <img src={no_notification} alt="no_notification" />
                <Typography>No Payments Yet!!</Typography>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <>
                <div className="payments-approve-container">
                  {payments.map((payment, index) =>
                    payment?.status === "Pending" ? (
                      <Tooltip title='View Order Details' placement="left-start" >
                        <div
                          key={index}
                          className="my-notifications"
                          onClick={() =>
                            navigate(
                              `/profile/approve-pay/approved-order-details/${payment?._id}`
                            )
                          }
                        >
                          <div className="notifications-details">
                            <Typography variant="h5">
                              For {payment?.for}
                            </Typography>
                            <Typography>
                              {payment?.payment?.description}
                            </Typography>
                            <Typography variant="h6">
                              Amount: <strong>₹{payment.amount}</strong>
                            </Typography>
                          </div>
                          <div className="notifications-date">
                            <Typography variant="h6">
                              Payment Date:{" "}
                              <strong>
                                {payment?.createdAt
                                  ? new Date(payment?.createdAt).toLocaleString()
                                  : "---"}
                              </strong>
                            </Typography>
                            <div className="approve">
                              {/* <Button className="approve-cancel-btn">Cancel</Button> */}
                              <Button
                                className="approve-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (payment?.payment_link) {
                                    window.open(payment?.payment_link, "_balnk");
                                  } else {
                                    toast.error("Payment Unavailable");
                                  }
                                }}
                                disabled={!payment?.payment_link}
                              >
                                {payment?.payment_link
                                  ? "Pay/Approve"
                                  : "Unavailable"}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Tooltip>
                    ) : (
                      ""
                    )
                  )}
                </div>
              </>
            </React.Fragment>
          )}
        </React.Fragment>
      </section>
    </React.Fragment>
  );
};

export default ApprovePay;
